var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLikeFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    fill: "currentColor",
    viewBox: "0 0 25 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.392 21.993 2.377 11.818C.332 9.738-.203 6.554 1.049 3.894 1.918 2.043 3.525.703 5.458.205a6.54 6.54 0 0 1 5.467 1.043c.591.422 1.078.96 1.453 1.575a5.419 5.419 0 0 1 1.454-1.575A6.549 6.549 0 0 1 19.3.205c1.933.498 3.54 1.845 4.41 3.69 1.251 2.666.716 5.85-1.33 7.93L12.393 22v-.007Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLikeFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LikeFilled.241ace5865eb84a8a1500c153d61048c.svg";